import { initialAlertState, useAlertStatus } from '../../../../customHook/useAlertStatus';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import { DocumentsTable } from './components/DocumentsTable';

export const Documents = () => {
  const { alertState, startOperation, completeOperation, setAlertState, getAlertContent } =
    useAlertStatus();

  return (
    <>
      <DocumentsTable startOperation={startOperation} completeOperation={completeOperation} />
      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </>
  );
};
